import React from 'react';
import NinjaGame from '../NinjaGame';
import { ALL_DRILLS } from '../DrillConstants';

const DepthTransitions = () => {
    const idx = ALL_DRILLS.findIndex(d => d.id === 'depth-transitions');
    return <NinjaGame initialDrillIndex={idx} />;
};

export default DepthTransitions;
